var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",class:_vm.currentLang == 'en' ? 'en-container' : '',attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view',{attrs:{"currentLang":_vm.currentLang}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }